(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-countdown]').forEach((section)=>{const end=Date.parse(section.dataset.countdown);if(!end)return;let timer;const tick=()=>{const raw=end-Date.now();if(raw<=0&&section.dataset.hideExpired==='true'){section.hidden=true;clearInterval(timer);return}const distance=Math.max(0,raw);const values=[Math.floor(distance/86400000),Math.floor(distance/3600000)%24,Math.floor(distance/60000)%60,Math.floor(distance/1000)%60];['days','hours','minutes','seconds'].forEach((key,index)=>{const node=section.querySelector(`[data-${key}]`);if(node)node.textContent=String(values[index]).padStart(2,'0')})};tick();timer=setInterval(tick,1000)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-scroll-top]').forEach((button)=>button.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'})));
document.querySelectorAll('.benchmark-footer__line').forEach((line)=>{const open=line.querySelector('[data-line-qr-open]');const modal=line.querySelector('[data-line-qr-modal]');const close=line.querySelector('[data-line-qr-close]');if(!open||!modal)return;open.addEventListener('click',()=>modal.showModal());close?.addEventListener('click',()=>modal.close());modal.addEventListener('click',(event)=>{if(event.target===modal)modal.close()});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information-tabs"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-tabs[data-tabs]').forEach((tabs)=>tabs.addEventListener('click',(event)=>{const button=event.target.closest('[role="tab"]');if(!button)return;tabs.querySelectorAll('[role="tab"]').forEach((item)=>{item.classList.toggle('is-active',item===button);item.setAttribute('aria-selected',String(item===button))});tabs.querySelectorAll('[role="tabpanel"]').forEach((panel)=>panel.classList.toggle('is-hidden',panel.id!==button.getAttribute('aria-controls')))}));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    document.querySelectorAll('[data-product-recommendations]').forEach((section)=>{if(!section.dataset.url)return;fetch(section.dataset.url).then((response)=>response.text()).then((text)=>{const html=new DOMParser().parseFromString(text,'text/html');const replacement=html.querySelector('[data-product-recommendations]');if(replacement&&replacement.innerHTML.trim())section.innerHTML=replacement.innerHTML}).catch(()=>{})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-wheel-rail"] && !Shopify.designMode) return;
  try {
    
(() => {
const GiftSeasons = (() => {
  const keys = ['newyear','valentine','whiteday','goldenweek','mothers','fathers','tanabata','respectaged','halloween','blackfriday','christmas'];
  const palettes = {
    brand: [['#e8b8b4','#f6d8d5','#b87f7a','#356a58','#d8b36d'],['#f3d8d1','#fff0ec','#cba8a0','#4f7667','#d8b36d'],['#d79da6','#edc5ca','#a86774','#315f50','#c9aa6a']],
    newyear: [['#f3ede2','#fffaf2','#d8cbb8','#c94b40','#d4a652'],['#b9473e','#dc786e','#7d2d28','#f0e3c8','#d6ad61'],['#315f51','#6f9484','#1b4035','#d14d42','#d8b36d']],
    valentine: [['#5a4038','#8c675d','#33231f','#8f2f47','#d5ad75'],['#7a2f42','#b65f73','#481827','#e8b7b2','#d9b477'],['#eadbd4','#fff3ed','#cbb7ae','#704052','#cba86f']],
    whiteday: [['#cbdbe4','#eef5f7','#91a9b6','#93b4c9','#d9c79c'],['#f3efe7','#ffffff','#d8d0c4','#a9bfd0','#d8b978'],['#8aa4b6','#bfd0db','#5e7788','#f2eee6','#d8c38e']],
    goldenweek: [['#315f73','#6f9bad','#183e4d','#d86b4b','#d8b15f'],['#e9e1c8','#fff8e8','#c9bb97','#2f6b78','#c99b43'],['#426e58','#7b9c83','#274936','#c94f42','#d5ab54']],
    mothers: [['#e6b5b7','#f6d8d8','#b87a7d','#c86672','#d5b273'],['#f3d8d0','#fff0eb','#c9a29a','#a75263','#d9b77b'],['#bd7788','#dda6b2','#814657','#f0ddd3','#c9a566']],
    fathers: [['#304d6a','#66829c','#1a3148','#d4a84e','#d7ba7a'],['#435d72','#7890a1','#263b4d','#d9b64f','#e1c98d'],['#e8e2d4','#fbf7ec','#c8bfaa','#2f516e','#d1aa58']],
    tanabata: [['#303c73','#6675a1','#1a234e','#d7b858','#e5cf83'],['#425a89','#7d91b7','#253b67','#e8d8a8','#d7b45e'],['#eee8dc','#fffaf1','#cfc4b3','#495d8e','#d1ac55']],
    respectaged: [['#756382','#a08fa9','#4b3c59','#d8ba70','#e1ca8e'],['#eee8df','#fffaf3','#cec3b5','#7a6685','#d2ad63'],['#5c4969','#8d7997','#392d43','#cda85a','#e1c686']],
    halloween: [['#d36e3f','#ef9a69','#8e3d23','#2f3331','#d4ad59'],['#333b38','#65706b','#1f2523','#df7845','#d5b766'],['#6e4e74','#9a799e','#422d47','#d97243','#d8b665']],
    blackfriday: [['#2f3331','#5d625f','#191c1b','#ef7f76','#c9ab70'],['#202523','#4a514d','#111413','#d76861','#d6b875'],['#4b3b3f','#735c61','#2b2023','#ef8b7e','#caa66b']],
    christmas: [['#285743','#608675','#17392c','#a83a3d','#d5b66f'],['#3d654f','#73937f','#244334','#c84b4e','#dfc686'],['#f0eadf','#fff8ef','#cfc4b4','#a83d43','#d0aa63']]
  };
  const nthWeekday = (year, month, weekday, nth) => 1 + (weekday - new Date(Date.UTC(year,month-1,1)).getUTCDay()+7)%7 + 7*(nth-1);
  const lastWeekday = (year, month, weekday) => {const last=new Date(Date.UTC(year,month,0));return last.getUTCDate()-(last.getUTCDay()-weekday+7)%7;};
  const easter = year => {
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3);
    const h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),n=h+l-7*m+114;
    return [Math.floor(n/31),n%31+1];
  };
  const events = year => [
    ['newyear',1,1,3],
    ['valentine',2,14,0],
    ['whiteday',3,14,0],
    ['goldenweek',4,29,6],
    ['mothers',5,nthWeekday(year,5,0,2),0],
    ['fathers',6,nthWeekday(year,6,0,3),0],
    ['tanabata',7,7,0],
    ['respectaged',9,nthWeekday(year,9,1,3),0],
    ['halloween',10,31,0],
    ['blackfriday',11,nthWeekday(year,11,5,4),3],
    ['christmas',12,25,0]
  ].map(([key,month,day,tail])=>({key,date:Date.UTC(year,month-1,day)/86400000,tail}));
  const japanDate = now => {
    const fields=Object.fromEntries(new Intl.DateTimeFormat('ja-JP',{timeZone:'Asia/Tokyo',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',hourCycle:'h23'}).formatToParts(now).map(part=>[part.type,part.value]));
    return {year:+fields.year,month:+fields.month,day:+fields.day,hour:+fields.hour};
  };
  const dailyOrder = (date,holiday) => {
    // A date-based shuffle is shared by every visitor and survives reloads.
    // Six permutations ensure each of the three styles appears exactly once.
    const seed=`iseebiz-gift-8h-v1|${date}|${holiday}`;
    let hash=2166136261;
    for(let index=0;index<seed.length;index++)hash=Math.imul(hash^seed.charCodeAt(index),16777619)>>>0;
    hash=Math.imul(hash^(hash>>>16),0x7feb352d)>>>0;
    hash=Math.imul(hash^(hash>>>15),0x846ca68b)>>>0;
    hash=(hash^(hash>>>16))>>>0;
    return [[1,2,3],[1,3,2],[2,1,3],[2,3,1],[3,1,2],[3,2,1]][hash%6].slice();
  };
  const resolve = (config, now=new Date()) => {
    const date=japanDate(now),today=Date.UTC(date.year,date.month-1,date.day)/86400000;
    let holiday='brand';
    if(config.enabled!==false && config.mode!=='brand') {
      if(keys.includes(config.mode))holiday=config.mode;
      else {
        const enabled=config.holidays||keys,lead=Math.max(0,Math.min(30,Number(config.leadDays) || 0));
        const matches=[...events(date.year-1),...events(date.year),...events(date.year+1)]
          .filter(event=>enabled.includes(event.key)&&today>=event.date-lead&&today<=event.date+event.tail)
          .sort((a,b)=>Math.abs(a.date-today)-Math.abs(b.date-today));
        if(matches[0])holiday=matches[0].key;
      }
    }
    const dateKey=`${date.year}-${String(date.month).padStart(2,'0')}-${String(date.day).padStart(2,'0')}`;
    const order=dailyOrder(dateKey,holiday),slot=Math.min(2,Math.floor(date.hour/8));
    const style=config.variant||'auto8h';
    const variant=style==='auto8h'?(holiday==='brand'?1:order[slot]):style==='rotate'?today%3+1:Math.max(1,Math.min(3,Number(style)||1));
    return {holiday,variant,palette:palettes[holiday]?.[variant-1],date:dateKey,slot,order,automatic:style==='auto8h'};
  };
  const assetUrl = () => '';
  const preload = () => Promise.resolve();
  const apply = (root,config,now) => {
    const chosen=resolve(config,now);root.dataset.holiday=chosen.holiday;root.dataset.skin=String(chosen.variant);root.dataset.holidayDate=chosen.date;
    root.dataset.seasonSlot=String(chosen.slot);root.dataset.seasonOrder=chosen.order.join(',');root.dataset.seasonRotation=chosen.automatic?'8h':'manual';
    const sculptureWrap=root.querySelector('[data-season-sculpture-wrap]');
    const sculptureImages=[...root.querySelectorAll('[data-season-sculpture]')];
    const sculptureUrl=chosen.holiday==='brand'?'':root.getAttribute(`data-sculpture-${chosen.holiday}`);
    root.dataset.sculpture=sculptureUrl?'japan':'false';
    if(sculptureWrap&&sculptureImages.length){
      if(sculptureUrl){
        sculptureImages.forEach(image=>{if(image.getAttribute('src')!==sculptureUrl) image.setAttribute('src',sculptureUrl);});
        sculptureWrap.hidden=false;
      }else{
        sculptureWrap.hidden=true;
        sculptureImages.forEach(image=>image.removeAttribute('src'));
      }
    }
    if(chosen.palette) {
      ['body','light','dark','ribbon','gold'].forEach((key,index)=>root.style.setProperty('--gift-'+key,chosen.palette[index]));
      root.querySelectorAll('[data-holiday-icon]').forEach(use=>use.setAttribute('href',`#GiftIcon-${root.dataset.iconId}-${chosen.holiday}`));
    } else ['body','light','dark','ribbon','gold'].forEach(key=>root.style.removeProperty('--gift-'+key));
    return chosen;
  };
  return {keys,palettes,events,japanDate,dailyOrder,resolve,assetUrl,preload,apply};
})();


// The opening is measured on each artwork, in the 340 × 640 stage.
// A matching foreground rim and pocket mask keep the card inside the vessel.
const GiftMouth = (() => {
  const profiles = {brand:[[170,433,112,16],[170,433,112,16],[170,433,112,16]]};
  const seasonal = [[170,438,94,12],[170,438,94,12],[170,438,94,12]];
  const clamp = value => Math.max(0,Math.min(1,value));
  const smooth = value => { const p=clamp(value);return p*p*(3-2*p); };
  const polygon = points => `polygon(${points.map(([x,y])=>`${x.toFixed(2)}px ${y.toFixed(2)}px`).join(',')})`;
  const prepare = root => {
    const pocket=root.querySelector('.gift-pocket'),front=root.querySelector('.gift-front');
    let key='',geometryKey='',mouth;
    return (ticket,progress,floatY) => {
      const selected=`${root.dataset.holiday}|${root.dataset.skin}`;
      if(selected!==key) {
        key=selected;
        mouth=(profiles[root.dataset.holiday]||(root.dataset.holiday==='brand'?profiles.brand:seasonal))[Math.max(0,Math.min(2,Number(root.dataset.skin)-1||0))];
        const [cx,cy,rx,ry]=mouth;
        const arc=Array.from({length:33},(_,i)=>{const angle=Math.PI*i/32;return [cx+rx*Math.cos(angle),cy+ry*Math.sin(angle)];});
        pocket.style.clipPath=polygon([[0,0],[340,0],[340,cy],...arc,[0,cy]]);
        root.dataset.mouth=mouth.join(',');
      }
      // Hidden gifts have zero layout dimensions. Never cache their mask;
      // recalculate from the actual foreground when it becomes measurable.
      const width=ticket.offsetWidth,height=ticket.offsetHeight;
      if(!front.offsetWidth || !front.offsetHeight || !width || !height) {
        geometryKey='';ticket.style.opacity='0';return;
      }
      const style=getComputedStyle(front);
      const geometry=[selected,front.offsetLeft,front.offsetTop,front.offsetWidth,front.offsetHeight,style.transform,style.transformOrigin].join('|');
      if(geometry!==geometryKey) {
        const [cx,cy,rx,ry]=mouth;
        const arc=Array.from({length:33},(_,i)=>{const angle=Math.PI*i/32;return [cx+rx*Math.cos(angle),cy+ry*Math.sin(angle)];});
        const rim=[[front.offsetLeft,cy],...arc.slice().reverse(),[front.offsetLeft+front.offsetWidth,cy],
          [front.offsetLeft+front.offsetWidth,front.offsetTop+front.offsetHeight],[front.offsetLeft,front.offsetTop+front.offsetHeight]];
        const matrix=new DOMMatrix(style.transform);
        const [ox,oy]=style.transformOrigin.split(' ').map(Number.parseFloat);
        const left=front.offsetLeft+ox*(1-matrix.a)+matrix.e;
        const top=front.offsetTop+oy*(1-matrix.d)+matrix.f;
        front.style.clipPath=polygon(rim.map(([x,y])=>[(x-left)/matrix.a,(y-top)/matrix.d]));
        geometryKey=geometry;
      }
      const [cx,cy,rx,ry]=mouth;
      const initialScale=Math.min(.44,Math.max(.28,(2*rx-16)/width));
      const lip=cy+ry,startBottom=lip+height*initialScale+14;
      // The lacquer bowl has a taller visible front than the flat seasonal boxes.
      // Lift the product card toward the lid so the inner cavity and front wall stay visible.
      const seasonalLift=root.dataset.holiday==='brand'?0:root.dataset.holiday==='halloween'?24:46;
      const boxEntry=root.dataset.holiday==='halloween'?14:0;
      const endBottom=Math.min(ticket.offsetTop+height+boxEntry,cy-12)-seasonalLift;
      const bottom=startBottom+(endBottom-startBottom)*progress;
      // Expand only after the upper portion has cleared the opening.
      const expandStart=lip+height*initialScale*.4,expandEnd=cy-8;
      const expansion=smooth((expandStart-bottom)/(expandStart-expandEnd));
      const scale=initialScale+(1-initialScale)*expansion;
      const finalX=ticket.offsetLeft+width/2;
      const center=cx+(finalX-cx)*smooth(progress);
      ticket.style.opacity=progress>0?'1':'0';
      ticket.style.transform=`translate(${center-finalX}px,${bottom-ticket.offsetTop-height+floatY}px) scale(${scale})`;
      root.dataset.cardScale=String(scale);root.dataset.cardBottom=String(bottom);
    };
  };
  return {prepare};
})();

  const initialize = root => {
    if (!root || root.dataset.ready === 'true') return;
    const stage = root.querySelector('[data-coupon-stage]');
    const body = root.querySelector('[data-gift-body]');
    const lid = root.querySelector('.gift-lid');
    const seal = root.querySelector('.gift-seal');
    const ticket = root.querySelector('[data-coupon-ticket]');
    const renderCard = GiftMouth.prepare(root);
    const slides = [...root.querySelectorAll('[data-coupon-slide]')];
    const dots = [...root.querySelectorAll('[data-gift-dot]')];
    const pause = root.querySelector('[data-coupon-pause]');
    const toggle = root.querySelector('[data-gift-toggle]');
    const dismiss = root.querySelector('[data-coupon-dismiss]');
    const modal = document.getElementById(slides[0]?.getAttribute('aria-controls'));
    if (!stage || !body || !lid || !seal || !slides.length || !modal) return;
    const mobile = matchMedia('(max-width:749px)');
    const wide = matchMedia('(min-width:1800px) and (min-height:720px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const designer = root.dataset.designMode === 'true';
    const seasonConfig = {enabled:root.dataset.seasonEnabled==='true',mode:root.dataset.seasonMode,variant:root.dataset.seasonVariant,leadDays:Number(root.dataset.seasonLead),holidays:root.dataset.seasonHolidays.split(',').filter(Boolean)};
    const artworkReady = GiftSeasons.preload(root,GiftSeasons.resolve(seasonConfig));
    GiftSeasons.apply(root,seasonConfig);
    let nextSeasonCheck = Math.floor(Date.now()/30000)*30000+30000;
    let seasonSwapPending = false;
    const desktopSize = Math.max(.8,Math.min(1.1,Number(root.dataset.desktopSize)/100 || 1));
    const mobileSize = Math.max(.8,Math.min(1.1,Number(root.dataset.mobileSize)/100 || 1));
    const welcome = document.querySelector('[data-iseebiz-welcome]');
    const welcomeIsOpen = () => Boolean(welcome && !welcome.hidden && welcome.classList.contains('is-open'));
    const welcomeAutoOpen = welcome?.dataset.autoOpen === 'true' && welcome?.dataset.customerSubscribed !== 'true';
    const navigationEntry = performance.getEntriesByType('navigation')[0];
    const isReload = navigationEntry ? navigationEntry.type === 'reload' : performance.navigation?.type === 1;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
    const save = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
    const prefix = 'iseebiz-gift-cycle-';
    const visit = prefix + 'visit-v2-';
    const customer = root.dataset.customer || 'guest';
    if (read(visit + 'customer') && read(visit + 'customer') !== customer) {
      save(visit + 'closes', '0'); save(visit + 'until', '0'); save(visit + 'runtime-v5','');
    }
    save(visit + 'customer', customer);
    let closeCount = designer ? 0 : Math.min(2, Number(read(visit + 'closes')) || 0);
    let snoozeUntil = designer ? 0 : Number(read(visit + 'until')) || 0;
    let dockPosition = null;
    try { dockPosition = JSON.parse(read(visit + 'dock')); } catch {}
    if (!dockPosition || !['left','right'].includes(dockPosition.side) || !Number.isFinite(dockPosition.anchor)) dockPosition = null;
    const home = document.createComment('ISEEBIZ gift home');
    root.before(home);
    let cartHost = null;
    let keyboardIntent = false;
    const arrival = Number(read(prefix + 'arrival')) || Date.now() - performance.now();
    save(prefix + 'arrival', String(arrival));
    const modulo = (value, length) => ((value % length) + length) % length;
    const clamp = value => Math.max(0, Math.min(1, value));
    const smooth = value => { const p = clamp(value); return p * p * (3 - 2 * p); };
    const mix = (from, to, progress) => from + (to - from) * progress;
    const interval = Math.max(2000, Number(root.dataset.rotationMs) || 2000);
    const stageHeight = 640;
    const closedCut = () => root.dataset.holiday === 'brand' ? 394 : 300;
    let cycle = 'waiting';
    let elapsed = 0;
    let layout = mobile.matches ? 'center' : 'featured';
    let placement = null;
    let placementMotion = null;
    let progressLid = 0;
    let progressPanel = 0;
    let returnPose = { lid: 1, panel: 1 };
    let phase = 0;
    let turn = null;
    let nextTurn = interval;
    const minimumExposure = Math.max(1000, interval - 640);
    let exposure = slides.map(() => 0);
    const offerSignature = slides.map(slide => slide.getAttribute('aria-label')).join('|');
    const allShown = () => exposure.every(time => time >= minimumExposure);
    const readRuntime = () => {
      try {
        const value = JSON.parse(read(visit + 'runtime-v5'));
        if (value?.version !== 5 || value.customer !== customer || value.offers !== offerSignature
          || !['waiting','dropping','opening','showing','retracting','settling','closed','snoozed','dismissed'].includes(value.cycle)
          || !Number.isFinite(value.phase) || !Number.isFinite(value.elapsed) || value.elapsed < 0) return null;
        return value;
      } catch { return null; }
    };
    let manualPaused = false;
    let held = null;
    let suppressUntil = 0;
    let linkReturning = false;
    let linkReturnTimer = null;
    let blocked = false;
    let assetsReady = false;
    let welcomeWasOpen = welcomeIsOpen();
    let welcomeClosed = designer || !welcome || !welcomeAutoOpen || (!isReload && read('iseebiz-welcome-jp-home-shown') === 'true' && !welcomeWasOpen);
    let disposed = false;
    let dismissed = closeCount >= 2;
    let lastTime = performance.now();
    let frame = null;
    let dropCount = 0;
    let openCount = 0;
    let shakeCount = 0;
    let geometryKey = '';
    let slideKey = '';
    const particles = [];
    const canvas = root.querySelector('[data-coupon-confetti]');
    const context = canvas?.getContext('2d');
    let burstCount = 0;
    let confettiTime = 0;
    const dimensions = () => {
      const viewport = visualViewport;
      const width = viewport?.width || innerWidth;
      const height = viewport?.height || innerHeight;
      const left = viewport?.offsetLeft || 0;
      const top = viewport?.offsetTop || 0;
      const header = Math.max(top, Math.min(top + height - 100, document.querySelector('.site-header')?.getBoundingClientRect().bottom || top));
      return { width, height, left, top, header };
    };
    const targetPlacement = kind => {
      const view = dimensions();
      if (mobile.matches) {
        const headroom=110;
        if (kind === 'dock') {
          const scale = .28 * mobileSize;
          const anchor = dockPosition ? view.top + dockPosition.anchor * view.height : view.header + 18 + (stageHeight+headroom) * scale;
          return { scale, left: view.left + (dockPosition?.side === 'right' ? view.width - 340 * scale - 14 : 14), anchor: Math.max((headroom?view.header:view.top) + (stageHeight+headroom) * scale + 22, Math.min(view.top + view.height - 12, anchor)) };
        }
        const scale = Math.max(.3, Math.min(.88 * mobileSize, (view.width - 40) / 340, (view.height - (view.header - view.top) - 34) / (stageHeight + (headroom||40))));
        const height = (stageHeight - closedCut() * (1 - Math.max(progressLid, progressPanel))) * scale;
        return { scale, left: view.left + (view.width - 340 * scale) / 2, anchor: view.top + Math.max((view.height - height) / 2, view.header - view.top + 14 + (headroom||40) * scale) + height };
      }
      const scale = kind === 'dock' ? .40 * desktopSize : Math.max(.3, Math.min((wide.matches ? 232 / 340 : .56) * desktopSize, (view.height - (view.header - view.top) - 38) / stageHeight));
      const width = 340 * scale;
      return { scale, left: wide.matches ? Math.max(12, (view.width - 1360) / 4 - width / 2) : 12, anchor: view.top + view.height - 52 };
    };
    const applyLayout = kind => {
      layout = kind;
      root.dataset.layout = kind;
      toggle.setAttribute('aria-expanded', String(kind !== 'dock'));
    };
    const place = (kind, animate = true, deferLayout = false) => {
      const target = targetPlacement(kind);
      if (!placement || !animate || reduced.matches) {
        applyLayout(kind);
        placement = target;
        placementMotion = null;
        delete root.dataset.targetLayout;
      } else {
        if (!deferLayout) applyLayout(kind);
        else root.dataset.targetLayout = kind;
        placementMotion = { from: { ...placement }, to: target, time: 0, duration: 820, kind, deferLayout };
      }
      lastTime = performance.now();
    };
    const selectCycle = next => {
      cycle = next;
      elapsed = 0;
      root.dataset.cycle = next;
      root.dataset.state = ['waiting','snoozed','dismissed'].includes(next) ? next : layout === 'dock' ? 'docked' : mobile.matches ? 'center' : 'desktop';
      if (next === 'dropping') { dropCount += 1; root.dataset.startedAt = String(performance.now()); }
      if (next === 'opening') { openCount += 1; root.dataset.openedAt = String(performance.now()); burst(); }
      if (next === 'showing') { root.dataset.showingAt = String(performance.now()); nextTurn = interval; exposure = slides.map(() => 0); }
      if (next === 'closed') root.dataset.closedAt = String(performance.now());
    };
    const keyboardPaused = () => cycle === 'showing' && keyboardIntent && root.contains(document.activeElement) && document.activeElement?.matches(':focus-visible') && document.activeElement !== pause;
    const frozen = () => blocked || modal.open || Boolean(held) || manualPaused || keyboardPaused();
    const paintSlides = () => {
      const current = modulo(Math.round(phase), slides.length);
      const key = `${phase.toFixed(5)}|${cycle}|${layout}|${mobile.matches}`;
      if (key === slideKey) return;
      slideKey = key;
      slides.forEach((slide, index) => {
        const offset = modulo(phase - index + slides.length / 2, slides.length) - slides.length / 2;
        const angle = Math.max(-1, Math.min(1, offset)) * Math.PI / 2;
        const radius = ticket.clientWidth / 2;
        slide.style.transform = `translate3d(${-radius * Math.sin(angle)}px,0,${radius * (Math.cos(angle) - 1)}px) rotateY(${-offset * 90}deg)`;
        slide.style.opacity = String(clamp((1 - Math.abs(offset)) / .18));
        slide.style.setProperty('--turn-shade', String(Math.min(1, Math.abs(offset)) * .35));
        slide.classList.toggle('is-current', current === index);
        slide.setAttribute('aria-hidden', String(index !== current || cycle !== 'showing'));
        slide.tabIndex = current === index && cycle === 'showing' && !(mobile.matches && layout === 'dock') ? 0 : -1;
      });
      dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(current === index)));
      root.querySelector('[data-coupon-position]').textContent = String(current + 1);
      root.dataset.current = String(current);
    };
    const navigate = steps => {
      if (cycle !== 'showing') return;
      const target = Math.round(phase) + steps;
      if (reduced.matches) { phase = target; turn = null; }
      else turn = { from: phase, to: target, time: 0, duration: 640 };
      nextTurn = interval;
      paintSlides();
    };
    const advanceCarousel = delta => {
      if (cycle !== 'showing' || frozen()) return;
      let stableTime = delta;
      if (turn) {
        stableTime = Math.max(0, delta - (turn.duration - turn.time));
        turn.time = Math.min(turn.duration, turn.time + delta);
        phase = mix(turn.from, turn.to, smooth(turn.time / turn.duration));
        if (turn.time >= turn.duration) { phase = turn.to; turn = null; }
      }
      if (!turn && Math.abs(phase - Math.round(phase)) < .001) {
        const current = modulo(Math.round(phase), slides.length);
        exposure[current] = Math.min(minimumExposure, exposure[current] + stableTime);
      }
      if (designer && allShown()) exposure=slides.map(()=>0);
      if (reduced.matches || allShown()) return;
      nextTurn -= delta;
      if (nextTurn <= 0 && !turn && exposure[modulo(Math.round(phase), slides.length)] >= minimumExposure) { navigate(1); nextTurn = interval; }
    };
    const burst = () => {
      if (!context || reduced.matches || designer || root.dataset.confettiEnabled !== 'true') return;
      burstCount += 1;
      const dpr = Math.min(devicePixelRatio || 1, 2);
      canvas.width = 460 * dpr; canvas.height = 820 * dpr;
      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      const colors = ['#e62e3b', '#3434c8', '#ffd45c', '#6f97ec', '#eecb90'];
      particles.length=0;
      const count=mobile.matches?180:260;
      for(let index=0;index<count;index+=1){
        const rain=index%2===0,side=index%4<2?-1:1;
        particles.push({source:rain?'top':'bottom',x:rain?Math.random()*340:170+side*(72+Math.random()*36),y:rain?-270+Math.random()*140:454,
          vx:rain?(Math.random()-.5)*65:side*(40+Math.random()*130),vy:rain?90+Math.random()*100:-(560+Math.random()*170),gravity:rain?145:580,
          color:colors[index%colors.length],width:index%3?4:2.5,length:index%3?8:22+Math.random()*18,ribbon:index%3===0,
          spin:(Math.random()-.5)*8,seed:Math.random()*6,born:Math.random()*(rain?500:160),life:rain?3300+Math.random()*350:2900+Math.random()*350});
      }
      confettiTime = 0;
    };
    const paintConfetti = delta => {
      if (!context || !particles.length) return;
      if (blocked || reduced.matches) { particles.length = 0; context.clearRect(0, 0, 460, 820); return; }
      confettiTime += delta;
      context.clearRect(0, 0, 460, 820);
      for (let index = particles.length - 1; index >= 0; index -= 1) {
        const p = particles[index];
        const age = confettiTime - p.born;
        if (age > p.life) { particles.splice(index, 1); continue; }
        if (age < 0) continue;
        const dt = Math.min(.045, delta / 1000);
        p.vy += p.gravity * dt; p.vx *= Math.exp(-.6 * dt);
        p.x += p.vx * dt; p.y += p.vy * dt;
        context.save(); context.translate(p.x + 60, p.y + 340); context.rotate(age / 1000 * p.spin);
        context.globalAlpha = clamp((p.life - age) / 550); context.fillStyle = p.color; context.strokeStyle = p.color;
        if (p.ribbon) { context.beginPath(); for (let n = 0; n <= 12; n += 1) { const x = Math.sin(n * .85 + age / 250 + p.seed) * 4; const y = (n / 12 - .5) * p.length; if (n === 0) context.moveTo(x, y); else context.lineTo(x, y); } context.lineWidth = p.width; context.stroke(); }
        else context.fillRect(-p.width / 2, -p.length / 2, p.width, p.length);
        context.restore();
      }
      root.dataset.confettiActive=String(particles.length);root.dataset.confettiTop=String(particles.filter(p=>p.source==='top').length);root.dataset.confettiBottom=String(particles.filter(p=>p.source==='bottom').length);
    };
    const beginReturn = () => {
      if (['waiting','dismissed','retracting','settling','closed'].includes(cycle)) return;
      returnPose = { lid: progressLid, panel: progressPanel };
      selectCycle('retracting');
      lastTime = performance.now();
    };
    const duration = () => {
      if (reduced.matches) return cycle === 'showing' || cycle === 'closed' ? Infinity : 0;
      return ({ dropping: 1100, opening: 980, showing: Infinity, retracting: 820, settling: 220, closed: 30000 })[cycle] ?? Infinity;
    };
    const finishChapter = () => {
      if (cycle === 'dropping') { selectCycle('opening'); }
      else if (cycle === 'opening') selectCycle('showing');
      else if (cycle === 'showing') { returnPose = { lid: 1, panel: 1 }; selectCycle('retracting'); }
      else if (cycle === 'retracting') selectCycle('settling');
      else if (cycle === 'settling') { selectCycle('closed'); place('dock', true, true); }
      else if (cycle === 'closed') { if (!mobile.matches && layout === 'dock') place('featured'); selectCycle('opening'); }
    };
    const advanceCycle = delta => {
      let remaining = delta;
      for (let attempts = 0; attempts < 12; attempts += 1) {
        const length = duration();
        const portion = Math.min(remaining, Math.max(0, length - elapsed));
        advanceCarousel(portion);
        elapsed += portion; remaining -= portion;
        if (cycle === 'showing' && allShown() && !turn && !designer) { finishChapter(); break; }
        if (elapsed < length || !Number.isFinite(length)) break;
        finishChapter();
        if (placementMotion || remaining <= 0 && duration() > 0) break;
      }
    };
    const render = () => {
      let dropY = 0, dropAngle = 0;
      if (cycle === 'opening') {
        const lidTime = clamp(elapsed / 780);
        const panelTime = clamp((elapsed - 60) / 800);
        progressLid = reduced.matches ? 1 : smooth(lidTime);
        progressPanel = reduced.matches ? 1 : smooth(panelTime);
      }
      else if (cycle === 'showing') { progressLid = 1; progressPanel = 1; }
      else if (cycle === 'retracting') {
        const lidDelay = linkReturning ? 45 : 120;
        const lidDuration = linkReturning ? 280 : 650;
        const panelDuration = linkReturning ? 210 : 500;
        progressLid = returnPose.lid * (1 - smooth((elapsed - lidDelay) / lidDuration));
        progressPanel = returnPose.panel * (1 - smooth(elapsed / panelDuration));
      }
      else { progressLid = 0; progressPanel = 0; }
      if (cycle === 'dropping') {
        const progress = clamp(elapsed / 1100);
        if (progress < .72) { const p = progress / .72; dropY = -(innerHeight / placement.scale + stageHeight) * (1 - p * p); dropAngle = -6 * (1 - p); }
        else if (progress < .9) { const p = (progress - .72) / .18; dropY = -23 * Math.sin(p * Math.PI); dropAngle = Math.sin(p * Math.PI) * 1.6; }
        root.dataset.dropProgress = String(progress);
      }
      root.dataset.shaking = 'false';
      body.style.transform = `translate(0px,${dropY}px) rotate(${dropAngle}deg)`;
      body.style.filter = 'none';
      const sealOpacity = smooth((.24 - progressLid) / .24);
      seal.style.opacity = String(sealOpacity);
      root.style.setProperty('--gift-shell-open', String(1-sealOpacity));
      lid.style.opacity = String(1 - sealOpacity);
      const lidOpenY = root.dataset.holiday === 'brand' ? -79 : -98;
      lid.style.transform = `translateY(${mix(335, lidOpenY, progressLid)}px) rotate(${mix(8, -2, progressLid)}deg)`;
      if (root.dataset.holiday !== 'brand') {
        const droppingScale = cycle === 'dropping' ? .92 : null;
        const lidTravel = 1 - (1 - progressLid) ** 2;
        root.style.setProperty('--season-lid-x', `${mix(0,10,lidTravel)}px`);
        const stackedSprite=root.dataset.holiday==='halloween';
        const seasonLidOpenY=stackedSprite?-365:-430;
        const seasonLidOpenScale=stackedSprite?1:.84;
        const seasonBaseOpenScale=stackedSprite?1:1.02;
        root.style.setProperty('--season-lid-y', `${mix(0,seasonLidOpenY,lidTravel)}px`);
        root.style.setProperty('--season-lid-tilt', `${mix(0,stackedSprite?-7:-14,lidTravel)}deg`);
        root.style.setProperty('--season-lid-rotate', `${mix(0,stackedSprite?-2:-5,lidTravel)}deg`);
        root.style.setProperty('--season-lid-scale', String(droppingScale ?? mix(1.04,seasonLidOpenScale,lidTravel)));
        root.style.setProperty('--season-base-y', `${mix(0,stackedSprite?0:-76,progressLid)}px`);
        root.style.setProperty('--season-base-scale', String(droppingScale ?? mix(1.04,seasonBaseOpenScale,progressLid)));
        root.style.setProperty('--season-cavity-opacity', String(smooth((progressLid-.08)/.42)));
        root.style.setProperty('--season-cavity-x', String(mix(.82,1,progressLid)));
        root.style.setProperty('--season-cavity-y', String(mix(.5,1,progressLid)));
        root.style.setProperty('--season-open-opacity', String(1-sealOpacity));
        root.style.setProperty('--season-closed-opacity', String(sealOpacity));
      }
      const openingPop = cycle === 'opening' && !reduced.matches ? -14 * Math.sin(Math.PI * clamp(elapsed / 520)) : 0;
      const floatY = cycle === 'showing' && !reduced.matches ? Math.sin(elapsed / 1200) * 2 : openingPop;
      renderCard(ticket,progressPanel,floatY);
      root.style.setProperty('--gift-panel', String(progressPanel));
      root.style.setProperty('--gift-shadow-scale', String(1 - floatY / 60));
      const cut = closedCut() * (1 - Math.max(progressLid, progressPanel));
      if (mobile.matches && layout === 'center' && !placementMotion) placement.anchor = targetPlacement('center').anchor;
      const width = 340 * placement.scale;
      const height = (stageHeight - cut) * placement.scale;
      const top = placement.anchor - height;
      const key = [width,height,top,placement.left,cut].map(n => n.toFixed(3)).join('|');
      if (key !== geometryKey) {
        geometryKey = key;
        root.style.setProperty('--gift-left', `${placement.left}px`); root.style.setProperty('--gift-top', `${top}px`);
        root.style.setProperty('--gift-width', `${width}px`); root.style.setProperty('--gift-height', `${height}px`);
        root.style.setProperty('--gift-scale', String(placement.scale)); root.style.setProperty('--gift-offset', `${-cut * placement.scale}px`);
      }
      root.dataset.layout = layout;
      const movingToDock = linkReturning && layout === 'dock' && Boolean(placementMotion);
      root.dataset.state = ['waiting','snoozed','dismissed'].includes(cycle) ? cycle : dismissed ? 'dismissed' : layout === 'dock' && !movingToDock ? 'docked' : mobile.matches ? 'center' : 'desktop';
      root.dataset.cycle = cycle; root.dataset.cycleElapsed = String(elapsed); root.dataset.lidProgress = String(progressLid); root.dataset.panelProgress = String(progressPanel);
      root.dataset.offersSeen = String(exposure.filter(time => time >= minimumExposure).length); root.dataset.offersTotal = String(slides.length); root.dataset.exposure = JSON.stringify(exposure);
      root.dataset.phase = String(phase); root.dataset.displayedPhase = String(phase); root.dataset.moving = String(Boolean(turn));
      root.dataset.closeWait = String(cycle === 'closed' ? 30000 - elapsed : 0);
      root.dataset.openCount = String(openCount); root.dataset.dropCount = String(dropCount); root.dataset.shakes = String(shakeCount); root.dataset.bursts = String(burstCount);
      root.dataset.confettiActive=String(particles.length);
      root.dataset.placing = String(Boolean(placementMotion)); root.dataset.held = String(Boolean(held));
      pause.setAttribute('aria-pressed', String(manualPaused || reduced.matches)); pause.setAttribute('aria-label', manualPaused || reduced.matches ? pause.dataset.playLabel : pause.dataset.pauseLabel);
      const sealed = cycle === 'closed' || cycle === 'settling';
      dismiss.setAttribute('aria-label', sealed ? closeCount ? 'Hide gift offers for this visit' : 'Hide gift offers for 5 minutes' : dismiss.dataset.minimizeLabel);
      dismiss.title = dismiss.getAttribute('aria-label');
      root.dataset.closeCount = String(closeCount); root.dataset.snoozeUntil = String(snoozeUntil);
      root.dataset.dockSide = dockPosition?.side || 'left';
      paintSlides();
    };
    // A modal cart makes the page inert. Keep the gift inside that modal, and
    // use the browser's top layer so the drawer cannot clip the floating gift.
    const syncCartLayer = () => {
      const cart = document.querySelector('dialog[data-cart-drawer][open]');
      const visible = !blocked && !dismissed && !['waiting','snoozed'].includes(cycle) && !modal.open;
      if (cartHost !== cart) {
        if (root.hasAttribute('popover')) {
          if (root.matches(':popover-open')) root.hidePopover();
          root.removeAttribute('popover');
        }
        cartHost = cart;
        if (cart) { cart.append(root); if (typeof root.showPopover === 'function') root.setAttribute('popover','manual'); }
        else if (home.isConnected) home.after(root);
      }
      if (root.hasAttribute('popover')) {
        if (visible && !root.matches(':popover-open')) root.showPopover();
        else if (!visible && root.matches(':popover-open')) root.hidePopover();
      }
      root.dataset.inCart = String(Boolean(cart));
    };
    const availability = () => {
      if (welcomeIsOpen()) welcomeWasOpen = true;
      else if (welcomeWasOpen && welcome?.hidden) welcomeClosed = true;
      const previous = blocked;
      blocked = !welcomeClosed || welcomeIsOpen() || document.hidden || [...document.querySelectorAll('dialog[open]')].some(dialog => dialog !== modal && !(designer && dialog===welcome) && !dialog.matches('[data-cart-drawer]')) || Boolean(document.querySelector('.mobile-nav[open]'));
      root.dataset.blocked = String(blocked);
      root.inert = blocked || dismissed || ['waiting','snoozed'].includes(cycle);
      syncCartLayer();
      if (previous !== blocked) lastTime = performance.now();
    };
    const restoreSnoozed = () => {
      snoozeUntil = 0; save(visit + 'until','0');
      manualPaused = false; held = null; turn = null;
      progressLid = 0; progressPanel = 0;
      place('dock',false); selectCycle('closed'); availability(); render();
    };
    const safeSeasonSwap = () => !held && !modal.open && !placementMotion && ['waiting','closed','snoozed','dismissed'].includes(cycle);
    const refreshSeason = async () => {
      if(disposed || seasonSwapPending)return;
      const next=GiftSeasons.resolve(seasonConfig);
      if(next.holiday===root.dataset.holiday && String(next.variant)===root.dataset.skin){GiftSeasons.apply(root,seasonConfig);return;}
      if(!safeSeasonSwap())return;
      seasonSwapPending=true;
      try{
        // Decode the next sculpted skin before atomically replacing the four frames.
        const url=GiftSeasons.assetUrl(root,next);
        await GiftSeasons.preload(root,next);
        if(!disposed && safeSeasonSwap() && GiftSeasons.assetUrl(root,GiftSeasons.resolve(seasonConfig))===url)GiftSeasons.apply(root,seasonConfig);
      }catch{/* Keep the current gift when a replacement asset cannot load. */}
      finally{seasonSwapPending=false;}
    };
    const tick = now => {
      if (disposed) return;
      const delta = Math.max(0, now - lastTime); lastTime = now;
      if(Date.now()>=nextSeasonCheck){nextSeasonCheck=Math.floor(Date.now()/30000)*30000+30000;refreshSeason();}
      if (cycle === 'snoozed' && Date.now() >= snoozeUntil && !dismissed) restoreSnoozed();
      if (!dismissed && cycle !== 'snoozed' && assetsReady) {
        if (cycle === 'waiting' && !blocked && welcomeClosed) {
          place(mobile.matches ? 'center' : 'featured', false); selectCycle(designer?'opening':'dropping'); root.inert = false;
        }
        if (placementMotion && !blocked && !modal.open && !held) {
          if (placementMotion.openOnMove && !frozen()) {
            advanceCycle(delta);
            placementMotion.to = targetPlacement(layout);
          }
          placementMotion.time += delta;
          const p = smooth(placementMotion.time / placementMotion.duration);
          placement = { scale: mix(placementMotion.from.scale,placementMotion.to.scale,p), left: mix(placementMotion.from.left,placementMotion.to.left,p), anchor: mix(placementMotion.from.anchor,placementMotion.to.anchor,p) };
          if (placementMotion.time >= placementMotion.duration) {
            const completedMotion = placementMotion;
            placement = completedMotion.to;
            placementMotion = null;
            if (completedMotion.deferLayout) {
              applyLayout(completedMotion.kind);
              delete root.dataset.targetLayout;
            }
          }
        } else if (cycle !== 'waiting' && !frozen() && !placementMotion) advanceCycle(delta);
        render(); paintConfetti(delta); syncCartLayer();
      }
      frame = requestAnimationFrame(tick);
    };
    const expand = () => {
      if (dismissed || blocked || cycle === 'snoozed' || layout !== 'dock') return;
      root.dataset.expandPhase = String(phase); root.dataset.expandCycle = cycle; root.dataset.expandElapsed = String(elapsed);
      const closed = cycle === 'closed' || cycle === 'settling';
      if (closed) { manualPaused = false; selectCycle('opening'); }
      place(mobile.matches ? 'center' : 'featured');
      if (closed && placementMotion) placementMotion.openOnMove = true;
      render();
    };
    const openPanel = index => {
      if (dismissed || blocked || ['waiting','snoozed'].includes(cycle)) return;
      modal.querySelectorAll('[data-coupon-offer]').forEach((offer, n) => offer.dataset.selected = String(n === modulo(index ?? Math.round(phase), slides.length)));
      if (!modal.open) modal.showModal(); lastTime = performance.now();
    };
    const followOffer = (link, event) => {
      if (linkReturning || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
      event.preventDefault();
      const destination = link.href;
      linkReturning = true; root.dataset.linkReturning = 'true';
      if (modal.open) modal.close();
      manualPaused = false; keyboardIntent = false; held = null; turn = null; particles.length = 0;
      returnPose = { lid: progressLid, panel: progressPanel };
      selectCycle('retracting');
      place('dock');
      if (placementMotion) { placementMotion.duration = 360; placementMotion.openOnMove = true; }
      render(); lastTime = performance.now();
      clearTimeout(linkReturnTimer);
      linkReturnTimer = setTimeout(() => {
        linkReturning = false; root.dataset.linkReturning = 'false';
        layout = 'dock'; placement = targetPlacement('dock'); placementMotion = null;
        progressLid = 0; progressPanel = 0; selectCycle('closed'); render(); persist();
        location.assign(destination);
      }, reduced.matches ? 80 : 420);
    };
    const allowClick = event => event.detail === 0 || Date.now() >= suppressUntil;
    root.addEventListener('click', event => {
      if (!allowClick(event)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (layout === 'dock' && !event.target.closest('[data-coupon-dismiss]')) { event.preventDefault(); event.stopImmediatePropagation(); expand(); }
    }, { ...options, capture: true });
    slides.forEach((slide,index) => slide.addEventListener('click', () => openPanel(index), options));
    toggle.addEventListener('click', () => {
      if (layout === 'dock') expand();
      else if (cycle === 'closed' || cycle === 'settling') { manualPaused = false; selectCycle('opening'); render(); }
      else openPanel();
    }, options);
    root.querySelector('[data-coupon-open]').addEventListener('click', () => openPanel(), options);
    dots.forEach((dot,index) => dot.addEventListener('click', () => navigate(modulo(index - Math.round(phase) + slides.length / 2, slides.length) - slides.length / 2), options));
    root.querySelector('[data-coupon-next]').addEventListener('click', () => navigate(1), options);
    root.querySelector('[data-coupon-previous]').addEventListener('click', () => navigate(-1), options);
    pause.addEventListener('click', () => { manualPaused = !manualPaused; lastTime = performance.now(); render(); }, options);
    dismiss.addEventListener('click', () => {
      if (cycle !== 'closed' && cycle !== 'settling') {
        manualPaused = false; keyboardIntent = false;
        if (root.contains(document.activeElement)) document.activeElement.blur();
        beginReturn(); render(); return;
      }
      closeCount = Math.min(2, closeCount + 1); save(visit + 'closes',String(closeCount));
      snoozeUntil = closeCount === 1 ? Date.now() + 300000 : 0; save(visit + 'until',String(snoozeUntil));
      dismissed = closeCount >= 2; manualPaused = false; turn = null;
      selectCycle(dismissed ? 'dismissed' : 'snoozed');
      if (root.contains(document.activeElement)) document.activeElement.blur();
      availability(); render();
    }, options);
    root.addEventListener('pointerdown', event => {
      if (event.button !== 0 || held || dismissed || blocked || ['waiting','snoozed'].includes(cycle) || event.target.closest('[data-coupon-dismiss],[data-coupon-open],.gift-dot,.coupon-offers__control')) return;
      const element = event.target.closest('button') || root;
      held = { id: event.pointerId, x: event.clientX, y: event.clientY, phase, began: performance.now(), moved: false, element, mode: mobile.matches && layout === 'dock' ? 'dock' : 'carousel', placement: { ...placement }, cycle };
      keyboardIntent = false;
      element.setPointerCapture(event.pointerId); lastTime = performance.now(); render();
    }, options);
    root.addEventListener('pointermove', event => {
      if (!held || held.id !== event.pointerId) return;
      const distance = event.clientX - held.x;
      if (held.mode === 'dock') {
        const dy = event.clientY - held.y;
        if (!held.moved && Math.hypot(distance,dy) < 7) return;
        held.moved = true; event.preventDefault(); placementMotion = null;
        const view = dimensions();
        placement.left = Math.max(view.left + 14, Math.min(view.left + view.width - 340 * placement.scale - 14, held.placement.left + distance));
        placement.anchor = Math.max(view.top + stageHeight * placement.scale + 22, Math.min(view.top + view.height - 12, held.placement.anchor + dy));
        render(); return;
      }
      if (cycle !== 'showing') return;
      if (!held.moved && Math.abs(distance) < 5) return;
      held.moved = true; event.preventDefault(); turn = null;
      phase = held.phase - distance / Math.max(1,ticket.getBoundingClientRect().width);
      root.dataset.dragDelta = String(distance); paintSlides();
    }, options);
    const release = event => {
      if (!held || held.id !== event.pointerId) return;
      const completed = held; held = null;
      if (completed.moved && completed.mode === 'dock') {
        const view = dimensions();
        const dx = event.clientX - completed.x;
        const side = dx > 12 ? 'right' : dx < -12 ? 'left' : placement.left + 170 * placement.scale > view.left + view.width / 2 ? 'right' : 'left';
        dockPosition = { side, anchor: (placement.anchor - view.top) / view.height };
        save(visit + 'dock',JSON.stringify(dockPosition));
        place('dock'); if (placementMotion) placementMotion.duration = 240;
      } else if (completed.moved) {
        const target = Math.round(phase);
        turn = reduced.matches ? null : { from: phase, to: target, time: 0, duration: 340 };
        if (reduced.matches) phase = target;
        nextTurn = interval; manualPaused = false;
      }
      // A stationary press on the closed box is a tap even when held slowly.
      // Long presses on an open product still must not accidentally follow it.
      if (completed.moved || completed.mode === 'carousel' && completed.cycle === 'showing' && performance.now() - completed.began > 240 || event.type !== 'pointerup') suppressUntil = Date.now() + 500;
      if (completed.element.hasPointerCapture(event.pointerId)) completed.element.releasePointerCapture(event.pointerId);
      lastTime = performance.now(); render();
    };
    root.addEventListener('pointerup', release, options); root.addEventListener('pointercancel', release, options); root.addEventListener('lostpointercapture', release, options);
    root.addEventListener('dragstart', event => event.preventDefault(), options);
    root.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); navigate(event.key === 'ArrowRight' ? -1 : 1); } }, options);
    root.addEventListener('focusout', () => { lastTime = performance.now(); }, options);
    document.addEventListener('keydown', () => { keyboardIntent = true; }, { ...options, capture: true });
    document.addEventListener('pointerdown', () => { keyboardIntent = false; }, { ...options, capture: true });
    document.addEventListener('pointermove',event=>{
      if(event.pointerType==='touch'||!placement)return;
      const bounds=root.getBoundingClientRect();
      root.dataset.hovered=String(root.contains(event.target)||(event.clientX>=bounds.left&&event.clientX<=bounds.right&&event.clientY>=bounds.top&&event.clientY<=bounds.bottom));
    }, {...options,passive:true});
    modal.querySelector('[data-coupon-dialog-close]').addEventListener('click', () => modal.close(), options);
    modal.addEventListener('close', () => { lastTime = performance.now(); availability(); }, options);
    modal.addEventListener('click', event => { if (event.target === modal) { const r = modal.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) modal.close(); } }, options);
    modal.addEventListener('click', event => { const link = event.target.closest('a[data-coupon-offer][href]'); if (link) followOffer(link, event); }, options);
    modal.querySelectorAll('[data-coupon-subscribe]').forEach(button => button.addEventListener('click', () => { modal.close(); window.dispatchEvent(new CustomEvent('iseebiz:welcome-request-open')); }, options));
    const reposition = () => {
      if (placementMotion) placementMotion.to = targetPlacement(layout);
      else placement = targetPlacement(layout);
      render();
    };
    window.addEventListener('resize', reposition, { ...options, passive: true }); window.addEventListener('scroll', reposition, { ...options, passive: true });
    visualViewport?.addEventListener('resize', reposition, { ...options, passive: true }); visualViewport?.addEventListener('scroll', reposition, { ...options, passive: true });
    mobile.addEventListener('change', () => { place(layout === 'dock' ? 'dock' : mobile.matches ? 'center' : 'featured',false); render(); }, options);
    wide.addEventListener('change', reposition, options);
    reduced.addEventListener('change', () => { if (reduced.matches && turn) { phase = turn.to; turn = null; } if (reduced.matches && placementMotion) { placement = placementMotion.to; placementMotion = null; } lastTime = performance.now(); render(); }, options);
    window.addEventListener('iseebiz:welcome-opened', () => { welcomeWasOpen = true; welcomeClosed = false; availability(); }, options);
    window.addEventListener('iseebiz:welcome-closed', () => { welcomeClosed = true; availability(); }, options);
    document.addEventListener('visibilitychange', availability, options);
    const observer = new MutationObserver(availability);
    observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open','hidden','class'], childList: true });
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root) || event.target.contains(home)) { disposed = true; clearTimeout(linkReturnTimer); cancelAnimationFrame(frame); observer.disconnect(); controller.abort(); if (root.hasAttribute('popover') && root.matches(':popover-open')) root.hidePopover(); if (modal.open) modal.close(); } }, options);
    const persist = () => {
      if(designer)return;
      save(visit + 'runtime-v5', JSON.stringify({ version: 5, customer, offers: offerSignature,
        cycle, elapsed, phase, exposure, nextTurn, turn, layout, returnPose,
        manualPaused, burstCount, openCount, dropCount, shakeCount }));
    };
    const restore = value => {
      closeCount = designer ? 0 : Math.min(2, Number(read(visit + 'closes')) || 0);
      snoozeUntil = designer ? 0 : Number(read(visit + 'until')) || 0;
      dismissed = closeCount >= 2;
      held = null; placementMotion = null; keyboardIntent = false;
      if (value) {
        cycle = value.cycle; elapsed = value.elapsed; phase = value.phase;
        exposure = slides.map((_,index) => Math.max(0,Math.min(minimumExposure,Number(value.exposure?.[index]) || 0)));
        nextTurn = Number.isFinite(value.nextTurn) ? value.nextTurn : interval;
        turn = value.turn && ['from','to','time','duration'].every(key => Number.isFinite(value.turn[key])) && value.turn.duration > 0 ? { ...value.turn } : null;
        layout = value.layout === 'dock' ? 'dock' : mobile.matches ? 'center' : 'featured';
        returnPose = value.returnPose || { lid: 1, panel: 1 };
        manualPaused = Boolean(value.manualPaused); burstCount = Number(value.burstCount) || 0;
        openCount = Number(value.openCount) || 0; dropCount = Number(value.dropCount) || 0;
        shakeCount = Number(value.shakeCount) || 0;
      } else {
        cycle = 'waiting'; elapsed = 0;
        layout = mobile.matches ? 'center' : 'featured';
      }
      if (dismissed) { cycle = 'dismissed'; elapsed = 0; }
      else if (snoozeUntil > Date.now()) { cycle = 'snoozed'; elapsed = 0; layout = 'dock'; }
      else if (cycle === 'snoozed' || cycle === 'dismissed' || !value && closeCount === 1) {
        cycle = 'closed'; elapsed = 0; layout = 'dock';
      }
      if (!welcomeClosed && !dismissed && cycle !== 'snoozed') {
        cycle = 'waiting'; elapsed = 0; progressLid = 0; progressPanel = 0;
        layout = mobile.matches ? 'center' : 'featured';
      }
      place(layout,false); render(); availability(); lastTime = performance.now();
      root.dataset.resumed = String(Boolean(value));
    };
    window.addEventListener('pagehide', persist, options);
    window.addEventListener('pageshow', event => {
      if (event.persisted) restore(readRuntime());
      lastTime = performance.now(); availability();
    }, options);
    document.addEventListener('visibilitychange', () => { if (document.hidden) persist(); }, options);
    restore(designer?null:readRuntime());
    root.dataset.ready = 'true';
    Promise.all([artworkReady.catch(() => {}), ...[...body.querySelectorAll('img')].map(image => image.decode?.().catch(() => {}) ?? Promise.resolve())]).then(() => { assetsReady = true; lastTime = performance.now(); });
    frame = requestAnimationFrame(tick);
  };
  document.querySelectorAll('[data-coupon-offers]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('[data-coupon-offers]')));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"]) return;
  try {
    document.querySelectorAll('[data-recently-viewed]').forEach(async(section)=>{const key='iseebiz-recent-products-v2';const legacyKey='iseebiz-recent-products';const current=section.dataset.productHandle;const currentImage=section.dataset.cardImage;let imageMap={};try{imageMap=JSON.parse(section.querySelector('[data-card-image-map]')?.textContent||'{}')}catch(error){imageMap={}}let records=[];try{records=JSON.parse(localStorage.getItem(key)||'[]')}catch(error){records=[]}if(!Array.isArray(records)||!records.length){try{const legacy=JSON.parse(localStorage.getItem(legacyKey)||'[]');if(Array.isArray(legacy))records=legacy.map((handle)=>({handle}))}catch(error){records=[]}}records=records.filter((record)=>record&&record.handle&&record.handle!==current);if(current)records.unshift({handle:current,image:currentImage||imageMap[current]||''});localStorage.setItem(key,JSON.stringify(records.slice(0,12)));const shown=records.filter((record)=>record.handle!==current).slice(0,Number(section.dataset.limit));if(!shown.length)return;const products=await Promise.all(shown.map((record)=>fetch(`/products/${encodeURIComponent(record.handle)}.js`).then((response)=>response.ok?response.json():null).then((item)=>item?{item,record}:null).catch(()=>null)));const grid=section.querySelector('[data-recent-grid]');products.filter(Boolean).forEach(({item,record})=>{const image=imageMap[record.handle]||record.image||item.featured_image||'';const imageUrl=image?`${image}${image.includes('?')?'&':'?'}width=720`:'';const price=(item.price/100).toLocaleString(document.documentElement.lang||undefined,{style:'currency',currency:item.currency||'JPY'});const card=document.createElement('article');card.className='recent-card';const link=document.createElement('a');link.href=item.url;if(imageUrl){const media=document.createElement('span');media.className='recent-card__media';const img=document.createElement('img');img.src=imageUrl;img.alt=item.title;img.width=720;img.height=720;img.loading='lazy';img.decoding='async';media.append(img);link.append(media)}const content=document.createElement('span');content.className='recent-card__content';const title=document.createElement('h3');title.textContent=item.title;const priceNode=document.createElement('span');priceNode.className='recent-card__price';priceNode.textContent=price;content.append(title,priceNode);link.append(content);card.append(link);grid.append(card)});if(grid.children.length)section.hidden=false});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-media-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-social-gallery][data-auto-rotate="true"]').forEach((gallery)=>{if(gallery.dataset.rotateReady)return;gallery.dataset.rotateReady='true';const track=gallery.querySelector('[data-social-track]');if(!track||!gallery.classList.contains('social-showcase--slider'))return;setInterval(()=>{const amount=track.firstElementChild?.getBoundingClientRect().width||0;const end=track.scrollLeft+track.clientWidth>=track.scrollWidth-4;track.scrollTo({left:end?0:track.scrollLeft+amount+16,behavior:'smooth'})},5000)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tabs]').forEach((tabs)=>{if(tabs.dataset.tabsReady)return;tabs.dataset.tabsReady='true';tabs.addEventListener('click',(event)=>{const button=event.target.closest('[role="tab"]');if(!button)return;tabs.querySelectorAll('[role="tab"]').forEach((item)=>{const active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',String(active))});tabs.querySelectorAll('[role="tabpanel"]').forEach((panel)=>panel.classList.toggle('is-hidden',panel.id!==button.getAttribute('aria-controls')))})});

  } catch(e) { console.error(e); }
})();
})();
